<template>
  <!-- <div>
    <router-view></router-view>
  </div> -->
  <div class="_body">
    <Header v-if="nowpage!='/login' && this.$store.state.frameDisplay" />
    <div class="_page">
      <sideMenu v-if="hideMenu && this.$store.state.frameDisplay" class="_sidemenu" />
      <div class="_content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import sideMenu from '@/components/sideMenu'
import Header from '@/components/header'
import { getCookieToken, isEmpty } from '@/utils/tool'
import store from '@/store'
export default {
  name: 'Home',
  components: {
    sideMenu,
    Header
  },
  data() {
    return {
      menulist: [],
      nowpage: '',
      hideMenu: true
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log('====')
        // 判断当前路由
        this.nowrouter()
      }
    }
  },

  created() {
    // 判断是否要重新登录
    this.havetoken()
    // 判断当前路由
    this.nowrouter()
  },
  // 挂载完成后，判断浏览器是否支持popstate
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL) // 这里有没有都无所谓，最好是有以防万一
      window.addEventListener('popstate', this.goBack, false)
      // 回退时执行goback方法
    }
  },
  methods: {
    goBack() {
      if (this.$cookies.get('yzd_qyState') == 1 && this.$cookies.get('isInit') == false) {
        this.$router.push('/')
      }
    },
    // 判断当前路由
    nowrouter() {
      console.log('----当前路由----')
      console.log(this.$route.path)
      this.nowpage = this.$route.path
      if (this.$route.path == '/login') {
        this.hideMenu = false
      } else if (this.$route.path == '/Rwsq') {
        this.hideMenu = false
      } else if (this.$route.path == '/rwsqstep') {
        this.hideMenu = false
      } else if (this.$route.path == '/Spfail') {
        this.hideMenu = false
      } else if (this.$route.path == '/Spload') {
        this.hideMenu = false
      } else {
        this.hideMenu = true
      }
    },
    handleOpen(key) {
      this.$router.push(key)
    },
    // 判断是否要重新登录
    havetoken() {
      const cookieToken = getCookieToken()
      if (isEmpty(cookieToken)) {
        this.$router.push('/login')
      } else if (isEmpty(store.state.token)) {
        store.commit('setToken', cookieToken)
      }
    }
  }
}
</script>

<style scoped>
.t_out{

}
  .t_login_bg{
    width:70%;

  }
  body{
    margin: 0;
    padding: 0;
  }
  *{
    box-sizing: border-box;
  }
  #app2{
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .t_contentbox{

  }
  .t_content_view{
    flex-shrink: 1;
    flex-grow: 1;
    overflow:scroll;
    width: 0;
  }
  .el-menu-item.is-active {
   background-color: #1C2E66 !important;
  }

  .el-menu-item, .el-submenu__title{
    height: 46px;
    line-height: 46px;
  }

  @media (min-width: 1280px) {
    .el-menu-item{
      font-size:0.5em;
      padding-left: 1.6vw !important;
    }
  }
  @media (min-width: 1366px) {
      .el-menu-item{
        font-size:0.5em;
        padding-left: 1.7vw !important;
      }
  }
  @media (min-width: 1440px) {
      .el-menu-item{
        font-size:0.6em;
        padding-left: 1.8vw !important;
      }
  }
  @media (min-width: 1680px) {
      .el-menu-item{
        font-size:0.8em;
        padding-left: 2vw !important;
      }
  }
  @media (min-width: 1920px) {
      .el-menu-item{
        font-size:0.9em;
        padding-left: 2.1vw !important;
      }
  }
</style>
